import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/TAYKUS.svg'
import _imports_1 from '../../assets/images/arrow-prev.svg'


const _withScopeId = n => (_pushScopeId("data-v-4f515848"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "relative w-full" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "absolute w-full",
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_2 = { class: "flex justify-between relative" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "slide-position flex" }
const _hoisted_6 = {
  key: 10,
  class: "next-button absolute w-full cursor-pointer"
}
const _hoisted_7 = { class: "relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActualLevelSelector = _resolveComponent("ActualLevelSelector")!
  const _component_GenderSelector = _resolveComponent("GenderSelector")!
  const _component_LevelCompetedSelector = _resolveComponent("LevelCompetedSelector")!
  const _component_PlayedSelector = _resolveComponent("PlayedSelector")!
  const _component_PlayedRackedSportSelector = _resolveComponent("PlayedRackedSportSelector")!
  const _component_MatchSelector = _resolveComponent("MatchSelector")!
  const _component_LessonsSelector = _resolveComponent("LessonsSelector")!
  const _component_AgeSelector = _resolveComponent("AgeSelector")!
  const _component_ConditionSelector = _resolveComponent("ConditionSelector")!
  const _component_InputLevel = _resolveComponent("InputLevel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("header", _hoisted_2, [
      (_ctx.selectedValue != 0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.moveIndicator(-1))),
            class: "cursor-pointer back-button h-8 w-8 flex justify-center items-center"
          }, _hoisted_4))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indicators, (indicator, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass([
          'indicator h-1 w-full',
          { 'select-indicator': index === _ctx.selectedValue },
          { 'select-indicator': index + 1 === _ctx.selectedValue },
          { 'select-indicator': index + 2 === _ctx.selectedValue },
          { 'select-indicator': index + 3 === _ctx.selectedValue },
          { 'select-indicator': index + 4 === _ctx.selectedValue },
          { 'select-indicator': index + 5 === _ctx.selectedValue },
          { 'select-indicator': index + 6 === _ctx.selectedValue },
          { 'select-indicator': index + 7 === _ctx.selectedValue },
          { 'select-indicator': index + 8 === _ctx.selectedValue },
          { 'select-indicator': index + 9 === _ctx.selectedValue },
        ])
          }, null, 2))
        }), 128))
      ])
    ]),
    (_ctx.selectedValue == 0)
      ? (_openBlock(), _createBlock(_component_ActualLevelSelector, {
          key: 0,
          onShowNextStep: _ctx.moveIndicator,
          propLevel: _ctx.tenis[0],
          onSelectedActualLevel: _ctx.handleSelectedOption
        }, null, 8, ["onShowNextStep", "propLevel", "onSelectedActualLevel"]))
      : _createCommentVNode("", true),
    (_ctx.selectedValue == 1)
      ? (_openBlock(), _createBlock(_component_GenderSelector, {
          key: 1,
          onShowNextStep: _ctx.moveIndicator,
          propGender: _ctx.tenis[1],
          onSelectedGender: _ctx.handleSelectedOption
        }, null, 8, ["onShowNextStep", "propGender", "onSelectedGender"]))
      : _createCommentVNode("", true),
    (_ctx.selectedValue == 2)
      ? (_openBlock(), _createBlock(_component_LevelCompetedSelector, {
          key: 2,
          onShowNextStep: _ctx.moveIndicator,
          propLevelCompeted: _ctx.tenis[2],
          onSelectedlevelCompeted: _ctx.handleSelectedOption
        }, null, 8, ["onShowNextStep", "propLevelCompeted", "onSelectedlevelCompeted"]))
      : _createCommentVNode("", true),
    (_ctx.selectedValue == 3)
      ? (_openBlock(), _createBlock(_component_PlayedSelector, {
          key: 3,
          onShowNextStep: _ctx.moveIndicator,
          propPlayed: _ctx.tenis[3],
          onSelectedPlayed: _ctx.handleSelectedOption
        }, null, 8, ["onShowNextStep", "propPlayed", "onSelectedPlayed"]))
      : _createCommentVNode("", true),
    (_ctx.selectedValue == 4)
      ? (_openBlock(), _createBlock(_component_PlayedRackedSportSelector, {
          key: 4,
          onShowNextStep: _ctx.moveIndicator,
          propPlayed: _ctx.tenis[4],
          onSelectedPlayedRackedSport: _ctx.handleSelectedOption
        }, null, 8, ["onShowNextStep", "propPlayed", "onSelectedPlayedRackedSport"]))
      : _createCommentVNode("", true),
    (_ctx.selectedValue == 5)
      ? (_openBlock(), _createBlock(_component_MatchSelector, {
          key: 5,
          onShowNextStep: _ctx.moveIndicator,
          propMatchPlayed: _ctx.tenis[5],
          onSelectedMatchPlayed: _ctx.handleSelectedOption
        }, null, 8, ["onShowNextStep", "propMatchPlayed", "onSelectedMatchPlayed"]))
      : _createCommentVNode("", true),
    (_ctx.selectedValue == 6)
      ? (_openBlock(), _createBlock(_component_LessonsSelector, {
          key: 6,
          onShowNextStep: _ctx.moveIndicator,
          propLesson: _ctx.tenis[6],
          onSelectedLesson: _ctx.handleSelectedOption
        }, null, 8, ["onShowNextStep", "propLesson", "onSelectedLesson"]))
      : _createCommentVNode("", true),
    (_ctx.selectedValue == 7)
      ? (_openBlock(), _createBlock(_component_AgeSelector, {
          key: 7,
          onShowNextStep: _ctx.moveIndicator,
          propAge: _ctx.tenis[7],
          onSelectedAge: _ctx.handleSelectedOption
        }, null, 8, ["onShowNextStep", "propAge", "onSelectedAge"]))
      : _createCommentVNode("", true),
    (_ctx.selectedValue == 8)
      ? (_openBlock(), _createBlock(_component_ConditionSelector, {
          key: 8,
          onShowNextStep: _ctx.moveIndicator,
          propCondition: _ctx.tenis[8],
          onSelectedCondition: _ctx.handleSelectedOption
        }, null, 8, ["onShowNextStep", "propCondition", "onSelectedCondition"]))
      : _createCommentVNode("", true),
    (_ctx.selectedValue == 9)
      ? (_openBlock(), _createBlock(_component_InputLevel, {
          key: 9,
          onShowNextStep: _ctx.moveIndicator,
          min: _ctx.minLevel,
          max: _ctx.maxLevel,
          sport: _ctx.Sport.TENIS,
          modelValue: _ctx.level,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.level) = $event)),
          onLevel: _ctx.handleLevel
        }, null, 8, ["onShowNextStep", "min", "max", "sport", "modelValue", "onLevel"]))
      : _createCommentVNode("", true),
    (_ctx.selectedValue < _ctx.indicators.length-1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("img", {
              class: "button-next-img absolute",
              src: _imports_1,
              alt: "",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.moveIndicator(1)))
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}